import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { includes } from "lodash";

import Header from "./Header";
import Subheader from "./Subheader";
import Loader from "components/Loader";
import StateStore from "globalStates/Store";
import AppStore from "context";
import useContextService from "hooks/useContextService";
import SidebarMenu from "./Sidebar";
import CoveredEntity from "components/CoveredEntity";
// import { Sidebar } from 'react-pro-sidebar';

const Next = () => {
  const location = useLocation();
  const { states, resetStates } = useContextService();
  const { loading } = states;

  useEffect(() => {
    const { pathname } = new URL(window.location.href);
    const hasPathChanged = !includes(pathname, "/claims-manager");
    if (hasPathChanged) {
      resetStates("claimsManager");
    }
  }, [location]);

  return (
    <>
      {loading && <Loader opacity={0.01} color="black" />}
      <Outlet />
    </>
  );
};

const Layout = (props) => {
  const { modules, onlOrgChange } = props;
  const [orgId, setOrgId] = useState(window.selectedOrganizationId);

  const onOrgChange = (orgId) => {
    setOrgId(orgId);
    onlOrgChange(orgId);
  };
  return (
    <AppStore>
      <StateStore>
        <section>
          <Header
            onOrgChange={onOrgChange}

          />
          <div className="main-gird">
            {/* <Subheader modules={modules} /> */}
            <SidebarMenu modules={modules} />
            <div className="bg-light">
              <Next />
            </div>
          </div>
        </section>
      </StateStore>
    </AppStore>
  );
};

export default Layout;
